import React, { useState, useEffect, Fragment, CSSProperties, useRef } from "react";
import { ListActionMenu, ListButton, ListControlButton, ListQueryPeriod } from "./listTableType";
import { FONT } from "../../../value/staticValues";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE, TABLE_QUERY_MENU_TYPE } from "../../../value/type";
import {
    StyleSheet, View,
} from "react-native";
import { ReactComponent as ControlButtonCollapsedImg } from "../../../img/ico-prefix-line-collapsed.svg";
import { ReactComponent as ControlButtonExpandedImg } from "../../../img/ico-prefix-line-expanded.svg";
import { ReactComponent as SearchClearButtonImg } from "../../../img/ico-prefix-search-clear.svg";
import { ReactComponent as SearchExecutionButtonImg } from "../../../img/ico-prefix-search.svg";
import { getCurrentTimestamp } from "../../../common/util";
import { QeuryMenuPeriodSearch } from "./queryMenu";

interface ActionMenuControlButtonItemProps {
    name: string;
    code: string;
    clickCb: Function;
    lastYn: boolean;
    firstYn: boolean;
    activeYn?: boolean;
    detectClickEventCb: Function;
}

function ActionMenuControlButtonItem(props:ActionMenuControlButtonItemProps) {
    const firstBorderRadiusStyle = "10px 10px 0px 0px";
    const lastBorderRadiusStyle = "0px 0px 10px 10px";
    const firstAndLastBorderRadiusStyle = "10px";
    const middleBorderRadiusStyle = "0px";
    const [activeYn, setActiveYn] = useState(props.activeYn);
    const [actionMenuControlButtonItemStyle, setActionMenuControlButtonItemStyle] = useState({...className.actionMenuControlButtonItem, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
    const [mouseHoverYn, setMouseHover] = useState(false);

    useEffect(() => {
        if(activeYn !== props.activeYn) {

            setActiveYn(props.activeYn);
        }
    }, [props.activeYn]);


    useEffect(() => {
        if(activeYn === false) {
            //disable
            setActionMenuControlButtonItemStyle({...className.actionMenuControlButtonItemDisabled, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
        } else {
            if(mouseHoverYn) {
                // hover
                setActionMenuControlButtonItemStyle({...className.actionMenuControlButtonItemHover, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
            } else {
                // normal
                setActionMenuControlButtonItemStyle({...className.actionMenuControlButtonItem, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
            }
        }

    }, [mouseHoverYn, activeYn]);


    const divRef = useRef(null);
    useEffect(() => {
        window.addEventListener("click", detectClickEvent);
        return () => {
            window.removeEventListener("click", detectClickEvent);
        };
    },[]);

    function detectClickEvent(event:MouseEvent) {
        props.detectClickEventCb(event, divRef);
    }

    function setMouseOver(hoverYn:boolean) {
        setMouseHover(hoverYn);
    }


    function clickItem() {
        if(activeYn !== false) {
            props.clickCb(props.code);
        }
    }
    return (
        <Fragment>
            <div style={actionMenuControlButtonItemStyle} ref={divRef}
                onMouseOut={() => { setMouseOver(false); }}
                onMouseOver={() => { setMouseOver(true); }}
                onClick={(e) => { clickItem(); }}
            >
                {props.name}
            </div>
            {
                props.lastYn ? null : <div style={className.actionMenuControlButtonItemDivContainer}></div>
            }
    </Fragment>
    )
}


interface ActionMenuControlButtonProps {
    id:number,
    name: string,
    activeYn: boolean,
    items: ListControlButton[],
    clickCb: Function,
}

function ActionMenuControlButton(props:ActionMenuControlButtonProps) {
    const [activeYn, setActiveYn] = useState(props.activeYn);
    const [actionMenuControlButtonStyle, setActionMenuControlButtonStyle] = useState(className.actionMenuControlButton);
    const [actionMenuControlButtonArrowStyle, setActionMenuControlButtonArrowStyle] = useState(className.actionMenuControlButtonExpandedImg);
    const [mouseHoverYn, setMouseHover] = useState(false);
    const [expandedYn, setExpandedYn] = useState(false);
    const divRef = useRef(null);
    useEffect(() => {
        if(activeYn !== props.activeYn) {
            setActiveYn(props.activeYn);
        }
    }, [props]);

    useEffect(() => {
        if(!activeYn) {
            //disable
            setActionMenuControlButtonStyle(className.actionMenuControlButtonDisabled);
            setActionMenuControlButtonArrowStyle({...className.actionMenuControlButtonExpandedImg, filter: "opacity(0.5) grayscale(0.5)"});
            if(expandedYn) {
                setExpandedYn(false);
            }
        } else {
            setActionMenuControlButtonArrowStyle(className.actionMenuControlButtonExpandedImg);
            if(mouseHoverYn) {
                // hover
                setActionMenuControlButtonStyle(className.actionMenuControlButtonHover);
            } else {
                // normal
                setActionMenuControlButtonStyle(className.actionMenuControlButton);
            }
        }
    }, [mouseHoverYn, activeYn]);

    function detectClickEvent(event:MouseEvent, element:any) {
        if(divRef.current == event.target) {
            return
        }

        if(!element.current || !element.current.contains(event.target)) {
            if(expandedYn) {
                setExpandedYn(false);
            }
        }
    }

    function setMouseOver(hoverYn:boolean) {
        if(activeYn) {
            setMouseHover(hoverYn);
        }
    }


    function clickButton() {
        if(activeYn) {
            setExpandedYn(!expandedYn);
        }
    }

    function clickSelectItem(code:any) {
        props.clickCb(code);
        setExpandedYn(false);
    }
    return (
        <View style={style.actionMenuControlButtonContainer}>
            <div style={actionMenuControlButtonStyle} ref={divRef}
                onMouseOut={() => { setMouseOver(false); }}
                onMouseOver={() => { setMouseOver(true); }}
                onClick={(e) => { clickButton(); }}
            >
                {props.name}
                {
                    expandedYn ?
                    <ControlButtonExpandedImg style={actionMenuControlButtonArrowStyle}/>:
                    <ControlButtonCollapsedImg style={actionMenuControlButtonArrowStyle}/>
                }
            </div>
            {
                expandedYn ?
                <div style={className.actionMenuControlButtonItemListContainer}>
                    {
                        props.items.map((item:ListControlButton, index) => {
                            if(index === 0) {
                                if(index === props.items.length - 1) {
                                    return (<ActionMenuControlButtonItem key={index} name={item.name} code={item.code} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={true} lastYn={true}  detectClickEventCb={detectClickEvent}/>)
                                } else {
                                    return (<ActionMenuControlButtonItem key={index} name={item.name} code={item.code} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={true} lastYn={false}  detectClickEventCb={detectClickEvent}/>)
                                }
                            } else {
                                if(index === props.items.length - 1) {
                                    return (<ActionMenuControlButtonItem key={index} name={item.name} code={item.code} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={false} lastYn={true}  detectClickEventCb={detectClickEvent}/>)
                                } else {
                                    return (<ActionMenuControlButtonItem key={index} name={item.name} code={item.code} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={false} lastYn={false}  detectClickEventCb={detectClickEvent}/>)
                                }
                            }

                        })
                    }
                </div>
                :null

            }
        </View>
    );
}

interface ActionMenuButtonItemProps {
    id:number,
    name: string,
    activeYn: boolean,
    item?: ListButton,
    clickCb: Function
}

function ActionMenuButtonItem(props:ActionMenuButtonItemProps) {
    const [activeYn, setActiveYn] = useState(props.activeYn);
    const [type, setType] = useState("");
    const [actionMenuButtonItemStyle, setActionMenuButtonItemStyle] = useState({});
    const [mouseHoverYn, setMouseHover] = useState(false);
    const [normalStyle, setNormalStyle] = useState({});
    const [disabledStyle, setDisabledStyle] = useState({});
    const [hoverStyle, setHoverStyle] = useState({});


    useEffect(() => {
        if(!props.item) {
            return ;
        }

        if(props.item.type !== type) {
            if(props.item.type === TABLE_BUTTON_TYPE.PUSH) {
                setNormalStyle(className.actionMenuButtonItemPush);
                setDisabledStyle(className.actionMenuButtonItemPushDisabled);
                setHoverStyle(className.actionMenuButtonItemPushHover);
            } else if(props.item.type === TABLE_BUTTON_TYPE.PUSH_WITH_ICON) {
                setNormalStyle(className.actionMenuButtonItemPushWithIcon);
                setDisabledStyle(className.actionMenuButtonItemPushWithIconDisabled);
                setHoverStyle(className.actionMenuButtonItemPushWithIconHover);
            } else if(props.item.type === TABLE_BUTTON_TYPE.DELETE) {
                setNormalStyle(className.actionMenuButtonItemDelete);
                setDisabledStyle(className.actionMenuButtonItemDeleteDisabled);
                setHoverStyle(className.actionMenuButtonItemDeleteHover);
            } else if(props.item.type === TABLE_BUTTON_TYPE.CANCEL) {
                setNormalStyle(className.actionMenuButtonItemCancel);
                setDisabledStyle(className.actionMenuButtonItemCancelDisabled);
                setHoverStyle(className.actionMenuButtonItemCancelHover);
            } else if(props.item.type === TABLE_BUTTON_TYPE.DARK_PUSH) {
                setNormalStyle(className.actionMenuButtonItemDarkPush);
                setDisabledStyle(className.actionMenuButtonItemDarkPushDisabled);
                setHoverStyle(className.actionMenuButtonItemDarkPushHover);
            } else if(props.item.type === TABLE_BUTTON_TYPE.NORMAL) {
                setNormalStyle(className.actionMenuButtonItemNormalPush);
                setDisabledStyle(className.actionMenuButtonItemNormalPushDisabled);
                setHoverStyle(className.actionMenuButtonItemNormalPushHover);
            } else {
                return ;
            }
            setType(props.item.type);
        }
        if(!activeYn) {
            setActionMenuButtonItemStyle(disabledStyle);
        } else {
            setActionMenuButtonItemStyle(normalStyle);
        }

        if(activeYn !== props.activeYn) {
            setActiveYn(props.activeYn);
        }
    }, [props]);


    useEffect(() => {

        if(!activeYn) {
            //disable
            setActionMenuButtonItemStyle(disabledStyle);
        } else {
            if(mouseHoverYn) {
                // hover
                setActionMenuButtonItemStyle(hoverStyle);
            } else {
                // normal
                setActionMenuButtonItemStyle(normalStyle);
            }
        }
    }, [mouseHoverYn, activeYn]);



    function setMouseOver(hoverYn:boolean) {
        if(activeYn) {
            setMouseHover(hoverYn);
        }
    }

    function clickItem(event:React.MouseEvent) {
        if(activeYn) {
            props.clickCb(props.item?props.item.code : "");
        }
    }



    return (
        <View style={style.actionMenuButtonItemContainer}>
            <div style={actionMenuButtonItemStyle}
                onMouseOut={() => { setMouseOver(false); }}
                onMouseOver={() => { setMouseOver(true); }}
                onClick={(e) => { clickItem(e); }}
                >
                {
                    (() => {
                        if(!props.item) return null;
                        if(!activeYn) {
                            return props.item.inactiveImgComponent ? <div style={className.actionMenuButtonItemImgContainer}> {props.item.inactiveImgComponent} </div>: null;
                        }
                        if(mouseHoverYn) {
                            return props.item.activeImgComponent ? <div style={className.actionMenuButtonItemImgContainer}> {props.item.activeImgComponent} </div>: null;
                        }
                        return props.item.imgComponent ? <div style={className.actionMenuButtonItemImgContainer}> {props.item.imgComponent} </div> : null;
                    })()
                }
                {props.name}
            </div>
        </View>
    );
}



interface ActionMenuProps {
    menus: ListActionMenu[];
    clickCb: Function;
    searchValue: string;
    searchCb: Function;
    periodClickCb: Function;
    searchBarYn: boolean;
    searchBarPlaceholder?: string;
}

function ActionMenu(props:ActionMenuProps) {
    const [menus, setMenus] = useState(props.menus);
    const [queryPeriod, setQueryPeriod] = useState<ListQueryPeriod>({type:"", startTs: getCurrentTimestamp() - 31536000, endTs: getCurrentTimestamp()});

    function clickMenuButtonItem(code:any) {
        props.clickCb(code);

    }

    function executeSearch(value:string) {
        props.searchCb(value);
    }
    function clickMenuPeriodRange(startTs:number, endTs:number) {
        setQueryPeriod({type:queryPeriod.type, startTs: startTs, endTs:endTs});
    }
    function clickMenuPeriodSearch() {
        props.periodClickCb(queryPeriod.type, queryPeriod.startTs, queryPeriod.endTs);
    }
    return (
        <View style={style.actionMenuContainer}>
            {
                menus.map((menu:ListActionMenu, index) => {
                    if(menu.type === TABLE_ACTION_MENU_TYPE.CONTROL_BUTTON) {
                        return <ActionMenuControlButton
                                key={index}
                                id={menu.id}
                                name={menu.name}
                                activeYn={menu.activeYn}
                                items={menu.controlButton ? menu.controlButton : []}
                                clickCb={clickMenuButtonItem}
                                />;
                    } else if(menu.type === TABLE_ACTION_MENU_TYPE.PUSH_BUTTON) {
                        return <ActionMenuButtonItem
                                key={index}
                                id={menu.id}
                                name={menu.name}
                                activeYn={menu.activeYn}
                                item={menu.button}
                                clickCb={clickMenuButtonItem}
                                />;
                    } else {
                        return null;
                    }

                })
            }

            {
                props.searchBarYn ?
                <ActionMenuSearchBar searchValue={props.searchValue} searchBarPlaceholder={props.searchBarPlaceholder} executeCb={executeSearch}/>
                : null
            }
            {
                (()=>{
                    let periodSearchYn = false;
                    let presetYn = false;
                    for(let button of menus) {
                        if(button.type === TABLE_QUERY_MENU_TYPE.CONTROL_PERIOD_BUTTON || button.type === TABLE_QUERY_MENU_TYPE.CONTROL_PERIOD_PRESET_BUTTON) {
                            periodSearchYn = true;
                        }
                        if(button.type === TABLE_QUERY_MENU_TYPE.CONTROL_PERIOD_PRESET_BUTTON) {
                            presetYn = true;
                        }
                    }
                    if(periodSearchYn) {
                        return <QeuryMenuPeriodSearch
                            period={queryPeriod}
                            periodClickCb={clickMenuPeriodRange}
                            searchClickCb={clickMenuPeriodSearch}
                            activeYn={queryPeriod.type || presetYn ? true : false}
                            presetYn={presetYn}
                            />
                    }
                })()
            }
        </View>
    )
}
interface ActionMenuSearchBarProps {
    searchValue: string;
    executeCb: Function;
    searchBarPlaceholder?: string;
}
function ActionMenuSearchBar(props:ActionMenuSearchBarProps) {
    const [searchValue, setSearchValue] = useState(props.searchValue);
    const [showSearchClearYn, setShowSearchClearYn] = useState(false);
    const [actionMenuSearchInputStyle, setActionMenuSearchInputStyle] = useState(className.actionMenuSearchInput);
    const [actionMenuSearchInputClearButtonStyle, setActionMenuSearchInputClearButtonStyle] = useState(className.actionMenuSearchInputClearButtonImg);
    const [actionMenuSearchInputExecutionButtonStyle, setActionMenuSearchInputExecutionButtonStyle] = useState(className.actionMenuSearchInputExecutionButtonImg);


    useEffect(() => {
        setSearchValue(props.searchValue);
    }, [props]);

    function executeSearch() {
        props.executeCb(searchValue);
    }

    function valueClear() {
        setSearchValue('');
    }

    return (
        <View style={style.actionMenuSearchBarContainer}>
            <form onSubmit={(e) => { executeSearch(); e.preventDefault();} }>
                <input type="text"
                    style={actionMenuSearchInputStyle}
                    value={searchValue}
                    placeholder={props.searchBarPlaceholder}
                    onChange={(e) => { setSearchValue(e.target.value); setShowSearchClearYn(e.target.value !== '') }}
                    onFocus={(e) => { setActionMenuSearchInputStyle(className.actionMenuSearchInputActive); }}
                    onBlur={(e) => { setActionMenuSearchInputStyle(className.actionMenuSearchInput); }}
                />
            </form>
                {
                    showSearchClearYn ?
                    <SearchClearButtonImg style={style.clearBtnStyle} onClick={()=> {valueClear()}}/> : null
                }
                <SearchExecutionButtonImg style={style.searchBtnStyle} onClick={()=> {executeSearch()}}/>


        </View>
    )
}



const style = StyleSheet.create({
    actionMenuContainer: {
        width: "inherit",
        height: 60,
        flexDirection: "row",
        padding: 12,
        borderRadius: 20,
        backgroundColor: "#f0f3fa",
        zIndex: 1

    },
    actionMenuButtonItemContainer: {
        height: 36,
    },
    actionMenuControlButtonContainer: {
        height: 36
    },
    actionMenuSearchBarContainer: {
        marginLeft: "auto",
        marginRight: 12,
        flexDirection: "row",
        alignItems: "center"
    },
    searchBtnStyle: {
        position: "absolute",
        marginLeft: "450px",
        cursor: "pointer"
    },
    clearBtnStyle: {
        position: "absolute",
        marginLeft: "420px",
        cursor: "pointer"
    }
});

const className = {
    actionMenuButtonItemImgContainer: {
        marginRight: "5px",
    },
    actionMenuButtonItemPush: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemPushHover: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemPushDisabled: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#f2f2f2",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    actionMenuButtonItemNormalPush: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#4f5fd8",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemNormalPushHover: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#414fb3",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemNormalPushDisabled: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#f2f4f7",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d4d9db",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    actionMenuButtonItemPushWithIcon: {
        height: "18px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px rgba(60, 93, 242, 0.5)",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#3c5df2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemPushWithIconHover: {
        height: "18px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px rgba(60, 93, 242, 0.5)",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
        backgroundColor: "#4f5fd8",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemPushWithIconDisabled: {
        height: "18px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
        backgroundColor: "#f2f4f7",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    actionMenuButtonItemDelete: {
        height: "38px",
        marginRight: "5px",
        padding: "9px 15px",
        borderRadius: "10px",
        backgroundColor: "#9ea0a5",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemDeleteHover: {
        height: "38px",
        marginRight: "5px",
        padding: "9px 15px",
        borderRadius: "10px",
        backgroundColor: "#626366",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemDeleteDisabled: {
        height: "38px",
        marginRight: "5px",
        padding: "9px 15px",
        borderRadius: "10px",
        backgroundColor: "#dcdfe6",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    actionMenuButtonItemCancel: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#a6a6a6",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemCancelHover: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#8c8c8c",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemCancelDisabled: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    actionMenuButtonItemDarkPush: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        backgroundColor: "#46494d",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemDarkPushHover: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        backgroundColor: "#333",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuButtonItemDarkPushDisabled: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        backgroundColor: "#dcdfe6",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    actionMenuControlButton: {
        height: "20px",
        marginRight: "5px",
        padding: "8px 8px 8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuControlButtonHover: {
        height: "20px",
        marginRight: "5px",
        padding: "8px 8px 8px 15px",
        borderRadius: "10px",
        border: "solid 1px #637aff",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuControlButtonDisabled: {
        height: "20px",
        marginRight: "5px",
        padding: "8px 8px 8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed",

    },
    actionMenuControlButtonExpandedImg: {
        width: "20px",
        height: "20px",
        marginLeft: "5px",
        filter: "none"
    },
    actionMenuControlButtonItem: {
        height: "20px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 0px #d4d9db",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuControlButtonItemHover: {
        height: "20px",

        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 0px #d4d9db",
        backgroundColor: "#637aff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    actionMenuControlButtonItemDisabled: {
        height: "20px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 0px #637aff",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    actionMenuControlButtonItemListContainer: {
        border: "solid 1px #d4d9db",
        borderRadius: "10px",
        marginRight: "5px"
    },
    actionMenuControlButtonItemDivContainer: {
        width: "inherit",
        height: "1px",
        border: "0px",
        backgroundColor: "#d4d9db"
    },

    actionMenuSearchInput: {
        width: "400px",
        height: "20px",
        padding: "8px 65px 8px 15px",
        border: "solid 1px #e4e7eb",
        borderRadius: "10px",
        boxShadow: "0 0 0 1px rgba(99, 122, 255, 0)",
        outline: "none",
        fontFamily: FONT.REGULAR,
        fontSize: "13px",
        lineHeight: "-0.05px",
        backgroundColor: "#fff"
    },
    actionMenuSearchInputActive: {
        width: "400px",
        height: "20px",
        padding: "8px 65px 8px 15px",
        border: "solid 1px #e4e7eb",
        borderRadius: "10px",
        boxShadow: "0 0 0 1px rgba(99, 122, 255, 0.5)",
        outline: "none",
        fontFamily: FONT.REGULAR,
        fontSize: "13px",
        lineHeight: "-0.05px",
        backgroundColor: "#fff"
    },


    actionMenuSearchInputClearButtonImg: {
        position: "absolute",
        marginLeft: "365px",
        cursor: "pointer"
    } as CSSProperties,
    actionMenuSearchInputExecutionButtonImg: {
        position: "absolute",
        marginLeft: "390px",
        cursor: "pointer"
    } as CSSProperties,


};

export default ActionMenu;